import React from 'react';
import { useAnalyticsEventTracker } from '../../utils/analytics';
import BuzzCountTrustLine from './BuzzCountTrustLine';

const BusinessHero = () => {
  const eventTracker = useAnalyticsEventTracker('BusinessHero');
  return (
    <>
      <div class="mx-auto flex max-w-screen-xl flex-row justify-center px-4 pt-8 pb-2 text-center md:pt-16 md:pb-8 lg:px-12 lg:pb-8">
        <div class="justify-center text-center lg:flex lg:w-2/3 lg:flex-grow lg:flex-col">
          <BuzzCountTrustLine theme="light" centered />
          <h1 class="mb-4 text-center font-syne-bold text-4xl leading-none tracking-tight text-black sm:mb-8 md:text-5xl lg:text-6xl">
            {'Automate Building Entry Across Your Portfolio'}
          </h1>
          <p class="text-md text-black-500 mb-1 font-space-grotesk-regular font-normal sm:px-16 lg:px-0 lg:text-lg xl:text-xl">
            Let guests, clients, residents, deliveries, and vendors buzz themselves into your buildings, no one has to
            answer a phone to open the door.
          </p>
          <p class="text-md text-black-500 mb-8 font-space-grotesk-regular font-normal sm:px-16 lg:px-0 lg:text-lg xl:text-xl">
            It works with the buzzers your buildings already have, no hardware installation required.
          </p>

          <div class="mb-8 flex flex-col items-stretch justify-center space-y-4 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-4">
            <a
              href="#download"
              className="inline-flex w-full items-center justify-center rounded-md border border-green-lowkey bg-green-lowkey py-2 px-5 text-base font-semibold text-black ring-green-lowkey hover:bg-black hover:text-green-lowkey hover:ring-2 focus:ring-1 sm:w-fit sm:px-7 xl:py-3 xl:px-7"
              onClick={() => eventTracker('download_navigate', undefined, 'ClickButton')}
            >
              Download
            </a>
            <a
              href="#features"
              className="inline-flex w-full items-center justify-center rounded-md border border-green-lowkey bg-black py-2 px-5 text-base font-semibold text-white ring-green-lowkey hover:ring-2 focus:ring-1 sm:w-fit sm:px-7 xl:py-3 xl:px-7"
              onClick={() => eventTracker('learn_more_business', undefined, 'ClickButton')}
            >
              Learn more
              <svg
                class="ml-2 -mr-1 h-5 w-5 rotate-90"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessHero;
